export const toggleClass = (selector: string, className: string) => {
  const element = document?.querySelector(selector);
  element?.classList?.toggle(className);
}

export const addClass = (selector: string, className: string) => {
  const element = document?.querySelector(selector);
  element?.classList?.add(className);
}

export const removeClass = (selector: string, className: string) => {
  const element = document?.querySelector(selector);
  element?.classList?.remove(className);
}

export const getHeight = (selector: string) => {
  const element: any = document?.querySelector(selector);
  return element?.offsetHeight;
}

export const styleDom = (selector: string, style: string, value: string) => {
  const element: any = document.querySelector(selector);
  if (element) {
    element.style[style] = value;
  }
}

export const position = (selector: string) => {
  const element = document.querySelector(selector);

  return element?.getBoundingClientRect() || {} as DOMRect;
}
